<app-device-features-container
  [header]="'+INSTALLATIONS.INSTALLATION.PANEL.ENERGY_COCKPIT.TITLE' | translate"
  [deviceSelectId]="deviceSelectId"
>
  <ng-container feature *ngIf="cumulativeProduced$ | async | ready as feature">
    <app-feature-tile
      class="full-width"
      [label]="'+INSTALLATIONS.INSTALLATION.ENERGY_COCKPIT.CUMULATIVE_PRODUCED.TITLE' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      isFullWidth="true"
    ></app-feature-tile>
  </ng-container>

  <ng-container feature *ngIf="cumulativePurchased$ | async | ready as feature">
    <app-feature-tile
      [label]="'+INSTALLATIONS.INSTALLATION.ENERGY_COCKPIT.CUMULATIVE_PURCHASED.TITLE' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      isFullWidth="true"
    ></app-feature-tile>
  </ng-container>

  <ng-container feature *ngIf="cumulativeSold$ | async | ready as feature">
    <app-feature-tile
      [label]="'+INSTALLATIONS.INSTALLATION.ENERGY_COCKPIT.CUMULATIVE_SOLD.TITLE' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      isFullWidth="true"
    ></app-feature-tile>
  </ng-container>
</app-device-features-container>
